'use client'
import { apartmentsTranslate } from '@/app/utils'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useParams, useSearchParams } from 'next/navigation'
import { FC } from 'react'
import Text from './common/Text'

const HotelsLoadingAnimation: FC = () => {
	const t = useTranslations('Main')
	const searchParams = useSearchParams()
	const params = useParams();
	const isEn = params.lang === 'en';
	const isAppatments = searchParams.get('p') === '12';

	return (
		<div className="text-center mx-auto pb-4">
			<Image
				src="/images/animations/hotels-animation.gif"
				width={75}
				height={56}
				unoptimized
				alt="Hotels loading animation"
				className="inline-block"
			/>

			<Text tag="h4" font="semibold" size="lg">
				{apartmentsTranslate(params.lang as string, isAppatments, t('loadingAnimationText'), false, true)}
			</Text>
		</div>
	)
}

export default HotelsLoadingAnimation
